<template>
  <div class="modal">
    <div @click="closeModal"
         class="modal__overlay fixed top-0 left-0 right-0 bottom-0 z-10 bg-black bg-opacity-70 flex justify-center items-center cursor-pointer">
    </div>
    <div class="modal__content fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
      <button @click="closeModal" class="absolute top-0 right-0 m-5">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
      <div class="p-5 bg-white rounded w-sm">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  methods: {
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
